import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteVenueContact($companyId: ID!, $id: ID!) {
    deleteVenueContact(companyId: $companyId, id: $id) {
      venueContact {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
